<script setup>
import { useQuasar } from 'quasar'
import useAddress from '../../../store/address.store'
import AddressUpdate from './Update.vue'
import AddressCreate from './Create.vue'
import PolygonPreview from './PolygonPreview.vue'
import { callApi, formatTime } from '../../../utils'
import Table from '../../shared/Table.vue'
import { useI18n } from "vue-i18n"

const { t } = useI18n()

const {
  addressList,
  getAddressList,
  loading,
  pagination,
  filterOptions
} = useAddress()

const $q = useQuasar()

const columns = [
  { name: 'name', align: 'left', label: t("addresses.name"), field: 'name' },
  { name: 'address', align: 'left', label: t("addresses.address"), field: v => [v.city, v.district, v.subDistrict, v.street, v.building].filter(Boolean).join(', ') },
  { name: 'map', align: 'center', label: t('menu.map'), field: () => '' },
  { name: 'prices', align: 'center', label: t('addresses.price'), field: () => '' },
  { name: 'customersNumber', align: 'center', label: t("addresses.customers"), field: v => v.customers?.length || 0 }
]

function paginate (props) {
  callApi([getAddressList], {
    ...filterOptions.value,
    page: parseInt(props.pagination.page),
    "page-size": parseInt(props.pagination.rowsPerPage)
  }, $q, loading)
}

function showUpdate (_, row) {
  $q.dialog({
    component: AddressUpdate,
    componentProps: { 
      id: row._id,
      fetch: fetch
    }
  })
}

function createAddress ( ){
  $q.dialog({
    component: AddressCreate
  })
}

function fetch() {
  callApi([getAddressList], {
    'page-size': parseInt(pagination.value.rowsPerPage)
  }, $q, loading)
}

fetch()
</script>

<template lang='pug'>
.address-list
  Table(
    :title='t("menu.addresses")'
    :rows='addressList'
    :loading='loading'
    :columns='columns'
    row-key='_id'
    v-model:pagination="pagination"
    @request="paginate"
    @row-click='showUpdate'
  )
    template(v-slot:header='props')
      q-th(v-for="(col, index) in props.cols" :key="col.name")
        div {{ col.label }}
    
    template(v-slot:body="props")
      template(v-for="col in props.cols" :key="col.name")
        q-td(v-if="col.name === 'map'" style="padding: 4px 8px;" @click.stop)
          PolygonPreview(:address="props.row")
        q-td(v-else-if="col.name === 'prices'" @click="showUpdate(props, props.row)")
          div(style="display: grid; grid-template-columns: auto auto; gap: 0 12px; text-align: left;" v-if="props.row.prices")
            span {{ t('addresses.price_entrance') }}
            span {{ props.row.prices.entrance }}₮
            span {{ t('addresses.price_garage') }}
            span {{ props.row.prices.garage }}₮
            span {{ t('addresses.price_barrier') }}
            span {{ props.row.prices.barrier }}₮
        q-td(v-else @click="showUpdate(props, props.row)")
          div {{ col.value }}
</template>
